module.exports = __webpack_public_path__ + "static/media/rss-feed.14a5b53f.svg";